import Immutable from 'seamless-immutable';
import {
  reducer as commonReducer,
  initialState as commonState,
} from '@common/InviteMemberModal';
import { ACTIONS } from './actions';
import { USER_ACCESSES } from '../constants';

export const initialState = ({
  show,
  DEFAULT_OPTION_COMPANIES,
  DEFAULT_OPTION_ROLES,
}) => {
  return Immutable.from({
    ...commonState({
      showMainModal: show,
      selectedCompany: DEFAULT_OPTION_COMPANIES,
      selectedRole: DEFAULT_OPTION_ROLES,
    }),
    selectedAccessLevel: USER_ACCESSES.MEMBER,
    productsAccesses: [],
    newlyCreatedProjectCompanies: [],
  });
};

export const reducer =
  ({ DEFAULT_OPTION_COMPANIES, DEFAULT_OPTION_ROLES }) =>
  (state, action) => {
    switch (action.type) {
      case ACTIONS.SET_ACCESS_LEVEL:
        return state.set('selectedAccessLevel', action.payload);
      case ACTIONS.SET_PRODUCTS_ACCESSES:
        return state.set('productsAccesses', action.payload);
      case ACTIONS.ADD_NEWLY_CREATED_PROJECT_COMPANIES:
        return state.set('newlyCreatedProjectCompanies', [
          ...state.newlyCreatedProjectCompanies,
          action.payload,
        ]);
      case ACTIONS.RESET_INFORMATION:
        return state.merge({
          ...commonReducer(state, action),
          selectedAccessLevel: USER_ACCESSES.MEMBER,
          productsAccesses: [],
          selectedCompany: DEFAULT_OPTION_COMPANIES,
          selectedRole: DEFAULT_OPTION_ROLES,
        });
      default:
        return commonReducer(state, action);
    }
  };
